import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddStandard, IStandard } from "../../Stream.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditStream = (standardId: string) => {
  const [formData, setFormData] = useState<IAddStandard>({
    standard: "",
    languageName: "",
    courseName: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [languages, setLanguages] = useState<any[]>();
  const [standard, setStandard] = useState<any[]>();
  const [courses, setCourses] = useState<IStandard[]>([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getCourse}/${standardId}`,
      });
      console.log("response", response);
      // setStandard(response);
      populateFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (standardData: IStandard) => {
    setFormData({
      standard: standardData.standard,
      languageName: standardData.languageName,
      courseName: standardData.courseName,
    });
  };

  //   useEffect(()=>{
  //   setFormData(prev => {...prev,standard})
  // },[standard])

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { id, type, value } = e.target;

    if (type === "file") {
      const files = (e.target as HTMLInputElement).files; // Files can be null

      if (files && files.length > 0) {
        setFormData((prev) => ({
          ...prev,
          [id]: files[0], // Store the first file
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value, // Store the value for select and input elements
      }));
    }
  };

  const fetchEducation = async () => {
    try {
      setLoading(true);
      const [standardsResponse] = await Promise.all([
        // ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
        // ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
      ]);

      console.log("Standard res : ",standardsResponse);
      setStandard(standardsResponse)
      // setCourses(coursesResponse);
      // setLanguages(languagesResponse);
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages."); // Show error toast
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    setLoading(true);
    // const formDataToSend = new FormData();
    // Object.entries(data).forEach(([key, value]) => {
    //   formDataToSend.append(key, value);
    // });
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateCourse}/${standardId}`,
        data: formData,
      });

        toast.success("Standard updated successfully", {
          duration: 10000,
        });
        // navigate("/stream");
        window.location.reload();
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000,
      });
      console.error("Error updating standard:", error);
    }
  };
  useEffect(() => {
    fetchEducation();
    fetchData();
  }, [standardId]);
  const handleCancel = () => {
    window.location.reload();
  };

  
  return {
    loading,
    formData,
    standard,
    languages,
    courses,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditStream;
